import { useNavigate } from 'react-router-dom';
import { useNotification } from '../../components/Notifications';
import { MessageForm } from './MessageForm';

export function MessageCreate() {
  const navigate = useNavigate();
  const {addNotification} = useNotification();

  return (
    <MessageForm
      messageId={0}
      onSuccess={() => {
        addNotification('Message created successfully!', 'success');
        navigate('/messages');
      }}
    />
  );
};
